import { render, staticRenderFns } from "./TransferCreateEdit.vue?vue&type=template&id=2dee5ea6&scoped=true&"
import script from "./TransferCreateEdit.vue?vue&type=script&lang=js&"
export * from "./TransferCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./TransferCreateEdit.vue?vue&type=style&index=0&id=2dee5ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dee5ea6",
  null
  
)

export default component.exports